module.exports = __webpack_public_path__ + "static/media/arrow.b7addc8f.svg";